//on production use .env 
export const APACHE_URL = process.env.REACT_APP_APACHE_URL
export const NAV_URL    = process.env.REACT_APP_NAV_URL
export const HRMIS      = process.env.REACT_APP_HRMIS 
export const HRMISPASS  = process.env.REACT_APP_NAV_PASS
export const APPNAME    = 'BRIDGE'

/**local testing */

// let setup = {ap: '',bc:'',us:'',ps:''}
// if(localStorage.getItem("MM_SET")){
//     setup = JSON.parse(localStorage.getItem("MM_SET"))
// }
// const APACHE_URL        = setup.ap
// const NAV_URL           = setup.bc
// export const HRMIS      = setup.us 
// export const HRMISPASS  = setup.ps

// Get company from local storage
export const COMPANY = (JSON.parse(localStorage.getItem("authMildUser")) == null) ? '' : JSON.parse(localStorage.getItem("authMildUser")).activeCompany;

/*LOGIN, REGISTER, PROFILE, RESET PASSWORD*/ 
export const GET_COMPANY            = APACHE_URL+"mildmay_api/company.php"
export const WSERVICES              = APACHE_URL+"mildmay_api/webServices.php"
export const POST_REGISTER          = APACHE_URL+"mildmay_api/register.php"
export const POST_LOGIN             = APACHE_URL+"mildmay_api/login.php"
export const POST_PASSWORD_FORGET   = APACHE_URL+"mildmay_api/forgotPassword.php"
export const POST_EDIT_PROFILE      = APACHE_URL+"mildmay_api/EditProfile.php"
export const CHANGEPASSWORD         = APACHE_URL+"mildmay_api/changePassword.php"
export const STAFF                  = APACHE_URL+"mildmay_api/staff.php"
export const COMPANIES              = APACHE_URL+"mildmay_api/company.php"

export const APPLICANT_REGISTER     = APACHE_URL+"mildmay_api/applicantsRegister.php"
export const APPLICANT_LOGIN        = APACHE_URL+"mildmay_api/applicantsLogin.php"

//MUG GENERAL
export const DELETERECORD           = NAV_URL+"ODataV4/HRActions_DeleteRecord"
export const EMPLOYEES  	        = NAV_URL+"api/hrpsolutions/hrmis/v1.0/employees"
export const ATTACHDOCUMENTS        = NAV_URL+"api/hrpsolutions/hrmis/v1.0/documentAttachments"
export const COST_CENTERS           = NAV_URL+"api/hrpsolutions/hrmis/v1.0/costCenters"
export const EMPLOYEES2             = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/employees"
export const CURRENCIES             = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/currencyCodes"
export const LOCATIONS              = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/locationCodes" 
export const GLACCOUNTS             = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/gLAccounts" 
export const ITEMS                  = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/items" 
export const FIXEDASSETS            = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/fixedAssets"  
export const UNITOFMEASURE          = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/unitOfMeasure"
export const CUSTOMERS  	        = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/customers"
export const VENDORS                = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/vendors"
export const WORKPLANS              = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/approvedWorkPlans"
export const WORKPLANENTRYNO        = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/approvedWorkPlansLines"
export const WORKPLANGLACCOUNTS     = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/approvedWorkPlansLines"
export const APPROVALENTRIES        = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/nflApprovalEntries"
export const BANKACCOUNTS           = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/bankAccounts"
export const DIMENSIONS             = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/dimensionValues"
export const APPROVALCOMMENTS       = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/rejectionComments"

// MUG BIO-DATA
export const DEPENDANTS             = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/dependants"
export const STAFFQUALIFICATIONS    = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/qualifications"
export const STAFFWORKEXPERIENCE    = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/workExperience"

// MUG LEAVE 
export const LEAVE_REQUESTS             = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/hRMLeaveRequests"
export const CAUSES_OF_ABSENCE          = NAV_URL+"api/hrpsolutions/hrmis/v1.0/causesofAbsence"
export const LEAVE_REQUEST_LINES        = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/leaveRequestLines"
export const APPROVE_LR                 = NAV_URL+"ODataV4/HRActions_ApproveLeaveRequest"
export const REJECT_LR                  = NAV_URL+"ODataV4/HRActions_RejectRequest"
export const APPROVALS                  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/requestsToApprove"
export const HRAPPROVALS                = NAV_URL+"api/hrpsolutions/hrmis/v1.0/hrrequestsToApprove"
export const SEND_LR_APPROVAL_REQUEST   = NAV_URL+"ODataV4/HRActions_SendLeaveApprovalRequest"
export const CANCEL_APPROVAL_REQUEST    = NAV_URL+"ODataV4/HRActions_CancelLeaveApprovalRequest"
export const PRINTLEAVE                 = NAV_URL+"ODataV4/HRMISActions_PrintLeaveForm"

//MUG EXIT
export const EXIT_INTERVIEWS                = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/exit"
export const EXIT_HANDOVER                  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/staffHandovers"
// export const EXIT_INTERVIEW                 = NAV_URL+"api/hrpsolutions/hrmis/v1.0/exitInterview"
export const EXIT_INTERVIEW4APPROVAL        = NAV_URL+"ODataV4/HRMISActions_SendExitInterviewApprovalRequest"
export const EXIT_INTERVIEW_CANCEL_APPROVAL = NAV_URL+"ODataV4/HRMISActions_CancelExitInterviewApprovalRequest"
export const DELETE_EXIT_INTERVIEW          = NAV_URL+"ODataV4/HRMISActions_DeleteExitInterview"


/*RECRUITMENT*/
export const POSITIONS              = NAV_URL+"api/hrpsolutions/hrmis/v1.0/positions"
export const SKILLS                 = NAV_URL+"api/hrpsolutions/hrmis/v1.0/skills"
export const RECRUITMENT_PROJECTS   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/recruitmentProjects"
export const APPLICANTS             = NAV_URL+"api/hrpsolutions/hrmis/v1.0/applicants"
export const NATIONALITIES          = NAV_URL+"api/hrpsolutions/hrmis/v1.0/nationalities"
export const PROJECT_POSITIONS      = NAV_URL+"api/hrpsolutions/hrmis/v1.0/recruitmentProjectPositions"
export const EMPLOYMENT_CONTRACTS   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/employmentContracts"
export const QUALIFICATIONS         = NAV_URL+"api/hrpsolutions/hrmis/v1.0/qualifications"
export const EMPLOYEE_QUALIFICATIONS= NAV_URL+"api/hrpsolutions/hrmis/v1.0/employeeQualifications"
export const PROFFESSIONAL_CERTIFICATIONS = NAV_URL+"api/hrpsolutions/hrmis/v1.0/professionalCertificates"
export const PROFESSIONAL_QUALIFICATION= NAV_URL+"api/hrpsolutions/hrmis/v1.0/professionalQualifications"
export const APPLICANT_EDUCATION       = NAV_URL+"api/hrpsolutions/hrmis/v1.0/applicantEducation"
export const APPLICANT_WORK_EXPERIENCE = NAV_URL+"api/hrpsolutions/hrmis/v1.0/applicantWorkExperience"
export const APPLICANT_CERTIFICATIONS  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/applicantCertifications"
export const RECRUITMENTS              = NAV_URL+"api/hrpsolutions/hrmis/v1.0/recruitments?$expand=recruitmentLines"
export const RECRUITMENTS1             = NAV_URL+"api/hrpsolutions/hrmis/v1.0/recruitments"
export const RRAPPROVAL                = NAV_URL+"ODataV4/HRMISActions_SendRecruitmentApprovalRequest?Company=MILDMAY"
export const RRCANCELAPPROVAL          = NAV_URL+"ODataV4/HRMISActions_CancelRecruitmentApprovalRequest?Company=MILDMAY"
export const RR2PROJECT                = NAV_URL+"ODataV4/HRMISActions_CreateProject?Company=MILDMAY" 

export const RECRUITMENTPROJECTS       = NAV_URL+"api/hrpsolutions/hrmis/v1.0/recruitmentProjectPositions?$expand=positionDescription,positionEducation,positionCertificates,positionSkills"
export const RECRUITMENTPROJECTSX      = NAV_URL+"api/hrpsolutions/hrmis/v1.0/recruitmentProjectPositions"
export const WORKEXPERIENCETYPES       = NAV_URL +"api/hrpsolutions/hrmis/v1.0/workExperienceType"
export const EDUCATIONTYPES            = NAV_URL +"api/hrpsolutions/hrmis/v1.0/professionalQualifications"
export const SUBMITAPPLICATION         = NAV_URL+"ODataV4/HRMISActions_SubmitApplication?Company=MILDMAY"


/*D&G*/
export const GRIEVENCES         = NAV_URL+"api/hrpsolutions/hrmis/v1.0/grievances"
export const GRIEVANCE_TYPES    = NAV_URL+"api/hrpsolutions/hrmis/v1.0/grievancesTypes"
export const GRIEVANCE_ACTIONS  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/grievancesActions"
export const RESOLVED_CASES     = NAV_URL+"api/hrpsolutions/hrmis/v1.0/resolvedCases"
export const WITHDRAWN_CASES    = NAV_URL+"api/hrpsolutions/hrmis/v1.0/withdrawnCases"

export const NOTIFY_SUPERVISOR  = NAV_URL+"ODATAV4/HRMISActions_GDNotifySupervisor"
export const GRIEVANCELINES     = NAV_URL+"api/hrpsolutions/hrmis/v1.0/grievanceLines"
export const SENDRESPONSE       = NAV_URL+"ODataV4/HRMISActions_SendResponseGriev"
export const CLOSECASE          = NAV_URL+"ODataV4/HRMISActions_CloseGrievance"
export const WITHDRAWCASE       = NAV_URL+"ODataV4/HRMISActions_WithdrawCase"
export const DELETECASE         = NAV_URL+"ODataV4/HRMISActions_DeleteGrievance"


/*COUNTS*/
export const COUNT_REQUESTS_TO_APPROVE  = NAV_URL+"ODataV4/HRMISActions_CountRequestsToApprove"  
export const COUNT_LEAVE_PLANS          = NAV_URL+"ODataV4/HRMISActions_CountLeavePlans"      
export const COUNT_LEAVE_REQUESTS       = NAV_URL+"ODataV4/HRMISActions_CountLeaveRequests" 
export const COUNT_EXIT_INTERVIEWS      = NAV_URL+"ODataV4/HRMISActions_CountExitInterviews" 
export const COUNT_STAFF_HAND_OVER      = NAV_URL+"ODataV4/HRMISActions_CountStaffHandovers" 
export const COUNT_TRAINING_REQUESTS    = NAV_URL+"ODataV4/HRMISActions_CountTrainingRequests" 
export const COUNT_RECRUITMENT_REQUESTS = NAV_URL+"ODataV4/HRMISActions_CountRecruitmentRequests"
export const COUNT_IPAS                 = NAV_URL+"ODataV4/HRMISActions_CountIPA"
export const COUNT_PERFORMANCE_APPRAISALS = NAV_URL+"ODataV4/HRMISActions_CountPerformanceAppraisals"
export const COUNT_IMPROVEMENT_PLANS    = NAV_URL+"ODataV4/HRMISActions_CountImprovementPlans"

export const NOTIF_CONTRACT             = NAV_URL+"api/hrpsolutions/hrmis/v1.0/contractNotifications"
export const NOTIF_BIRTHDAYS            = NAV_URL+"api/hrpsolutions/hrmis/v1.0/birthDayNotifications"

export const PRINT_PAYSLIP              = NAV_URL+"ODataV4/HRMISActions_PrintPaySlip"
export const PRINT_NSSF                 = NAV_URL+"ODataV4/HRMISActions_PrintNSSFForm"
export const PRINT_PAYEE                = NAV_URL+"ODataV4/HRMISActions_PrintPAYEReport"
export const PRINT_RBS                  = NAV_URL+"ODataV4/HRMISActions_PrintRBSReport"

//PERFORMANCE MGT
export const COMPETENCIES           = NAV_URL+"api/hrpsolutions/hrmis/v1.0/competencies"
export const IPAS_X                     = NAV_URL+"api/hrpsolutions/hrmis/v1.0/ipas" 
export const IPAS                       = NAV_URL+"api/hrpsolutions/hrmis/v1.0/ipas?$expand=ipaLines,ipaLines2,ipaLines3,ipaLines4" 
export const IPALINE1                   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/ipaLines" 
export const IPALINE2                   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/ipaLines2"
export const IPALINE3                   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/ipaLines3"
export const IPALINE4                   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/ipaLines4"
export const PAS                        = NAV_URL+"api/hrpsolutions/hrmis/v1.0/pAs?$expand=pALines,pALines2"
export const PAS_X                      = NAV_URL+"api/hrpsolutions/hrmis/v1.0/pAs"
export const MPAS                       = NAV_URL+"api/hrpsolutions/hrmis/v1.0/midyearPAs"
export const MPAS_X                     = NAV_URL+"api/hrpsolutions/hrmis/v1.0/midyearPAs?$expand=mpaLines,mpaLines2,mpaLines4"
export const FPAS                       = NAV_URL+"api/hrpsolutions/hrmis/v1.0/staffPerformanceReviews"
export const FPAS_X                     = NAV_URL+"api/hrpsolutions/hrmis/v1.0/staffPerformanceReviews?$expand=paLines1,paLines2,paLines3,paLines4,paLines5,paLines6"
export const MPA_LINES                  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/mpaLines"
export const MPA_LINES2                 = NAV_URL+"api/hrpsolutions/hrmis/v1.0/mpaLines2"
export const MPA_LINES4                 = NAV_URL+"api/hrpsolutions/hrmis/v1.0/mpaLines4"
export const SENDMIDTERMTOAPPRAISER     = NAV_URL+"ODataV4/HRMISActions_SendToAppraiser"
export const SENDFULLTERMTOAPPRAISER    = NAV_URL+"ODataV4/HRMISActions_SendToAppraiserFullterm"
export const APPROVEFULLTERMAPPRAISAL   = NAV_URL+"ODataV4/HRMISActions_ApproveFulltermAppraisal"
export const CONFIRMMIDTERMJOINTREVIEW  = NAV_URL+"ODataV4/HRMISActions_ConfirmMidtermJointReview"
export const CONVERTMID2FULLYEAR        = NAV_URL+"ODataV4/HRMISActions_ConvertToAnnualPerformanceAppraisal"
export const PA_LINES                   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/paLines1"
export const PA_LINES2                  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/paLines2"
export const PA_LINES3                  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/paLines3"
export const PA_LINES4                  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/paLines4"
export const PA_LINES5                  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/paLines5"
export const PA_LINES6                  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/paLines6"
export const SEND2APPRAISER             = NAV_URL+"ODataV4/HRMISActions_SendToAppraiser"
export const CLOSE_PA                   = NAV_URL+"ODataV4/HRMISActions_CloseAppraisal"
export const PRINTAPPRAISAL             = NAV_URL+"ODataV4/HRMISActions_PrintIPAForm"
export const MIP                        = NAV_URL+"api/hrpsolutions/hrmis/v1.0/improvementPlans?$expand=improvementLines"
export const SENDIPA4APPROVAL           = NAV_URL+"ODataV4/HRMISActions_SendIPAApprovalRequest"
export const CANCELIPAAPPROVAL          = NAV_URL+"ODataV4/HRMISActions_CancelIPAApprovalRequest"
export const CONVERT2PA                 = NAV_URL+"ODataV4/HRMISActions_ConvertToPerformanceAppraisal"
export const PIPS_X                     = NAV_URL+"api/hrpsolutions/hrmis/v1.0/pips"
export const PIPS                       = NAV_URL+"api/hrpsolutions/hrmis/v1.0/pips?$expand=pipLines,pipLines2" 
export const PIPLINE1                   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/pipLines" 
export const PIPLINE2                   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/pipLines2"
export const SENDPIP4APPROVAL           = NAV_URL+"ODataV4/HRMISActions_SendPIPApprovalRequest"
export const SENDPIPREVIEWAPPROVAL      = NAV_URL+"ODataV4/HRMISActions_SendPIPReviewRequest"
export const REOPENDOCUMENT             = NAV_URL+"ODataV4/HRMISActions_ReopenDocument"
export const APPROVENFLREQUEST          = NAV_URL+"ODataV4/HRMISActions_ApproveNFLRequest"
export const REJECTNFLREQUEST           = NAV_URL+"ODataV4/HRMISActions_RejectNFLApprovalRequest"  

//DASHBOARD
export const EMPLOYEE_CONTRACTS         = NAV_URL+"api/hrpsolutions/hrmis/v1.0/employmentContracts"
export const CONTRACT_NOTIFICATIONS     = NAV_URL+"api/hrpsolutions/hrmis/v1.0/contractNotifications"

/**PAYMENTS*/
// export const PAYMENTREQUISITIONS        = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/paymentRequisition"
// export const PAYMENTREQUISITIONX        = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/paymentRequisition?expand=paymentReqSubform"
// export const PAYMENTLINE                = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/paymentReqSubform"
// export const PAYMENTCATEGORIES          = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/paymentCategory"
// export const PAYMENTSUBCATEGORIES       = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/paymentSubCategory"
// export const PAYEETYPE_CUSTOMER         = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/customerList?$filter=Staff eq false"
// export const PAYEETYPE_VENDOR           = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/vendorList"
// export const PAYEETYPE_IMPREST          = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/customerList?$filter=Staff eq true"
// export const PAYEETYPE_BANK             = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/bankAccountList"
// export const CURRENCYLIST               = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/currencyCode"

// export const LPOLIST                    = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/lpoList"
// export const CALLOFFORDERSLIST          = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/callOffOrderList"
// export const DIRECTINVOICESLIST         = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/directInvoices"
// export const CONTRACTSLIST              = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/contractsList"
// export const GLACC                      = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/glAccountList?$filter=DirectPosting eq true and AccountType eq 'Posting' and Blocked eq false"

// export const COSTCENTERCODES            = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/costCenterCodes"
// export const PROJECTCODES               = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/projectCodes"
// export const APPROVERCODELIST           = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/departmentApprovalUserSetup"

// export const SEND4APPROVAL              = NAV_URL+"ODataV4/ProcureToPayAPIActions_sendPaymentRequisitionApprovalRequest?Company='MILDMAY'"
// export const CANCELAPPROVAL             = NAV_URL+"ODataV4/ProcureToPayAPIActions_cancelPaymentRequisitionApprovalRequest?Company='MILDMAY'"
// export const APPROVALHISTORY            = NAV_URL+"api/hrpsolutions/paymentProcess/v2.0/prApprovalHistory"
// export const ACHIEVEPAYMENTREQUISITION  = NAV_URL+"ODataV4/ProcureToPayAPIActions_archivePaymentRequisition?Company='MILDMAY'"
// export const PRINTPAYMENTREQUISITION    = NAV_URL+"ODataV4/ProcureToPayAPIActions_printPaymentRequisition?Company='MILDMAY'"

// export const APPROVEPAYMENT             = NAV_URL+"ODataV4/ProcureToPayAPIActions_approvepaymentRequest?Company='MILDMAY'"
// export const REJECTPAYMENT              = NAV_URL+"ODataV4/ProcureToPayAPIActions_rejectpaymentRequest?Company='MILDMAY'"

/**TRAINING */
export const PDP                        = NAV_URL+"api/hrpsolutions/hrmis/v1.0/personalDevtPlan"
export const PDPEXPAND                  = NAV_URL+"api/hrpsolutions/hrmis/v1.0/personalDevtPlan?$expand=personalDevtPlanLines"
export const PDPAPPROVAL                = NAV_URL+"ODataV4/HRMISActions_SendPDPApprovalRequest"
export const PDPCANCELAPPROVAL          = NAV_URL+"ODataV4/HRMISActions_CancelPDPApprovalRequest"

export const COURSES                    = NAV_URL+"api/hrpsolutions/hrmis/v1.0/courses"
export const CONFERENCES                = NAV_URL+"api/hrpsolutions/hrmis/v1.0/conferences"
export const CERTIFICATES               = NAV_URL+"api/hrpsolutions/hrmis/v1.0/professionalCertificates"
export const COACHING                   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/coaching"

export const TRAININGPLAN               = NAV_URL+"api/hrpsolutions/hrmis/v1.0/trainingPlan"
export const TRAININGPLANEXPAND         = NAV_URL+"api/hrpsolutions/hrmis/v1.0/trainingPlan?$expand=trainingPlanLines"
export const TRAININGREQUESTCOURSES     = NAV_URL+"api/hrpsolutions/hrmis/v1.0/trainingRequestsCourses"
export const TRAININGGROUPS             = NAV_URL+"api/hrpsolutions/hrmis/v1.0/traininggroups"
export const ACCOUNTS                   = NAV_URL+"api/hrpsolutions/hrmis/v1.0/chartofaccounts"
export const BUDGETS                    = NAV_URL+"api/hrpsolutions/hrmis/v1.0/budgets"
export const VENUES                     = NAV_URL+"api/hrpsolutions/hrmis/v1.0/venues"
    
// MUG PURCHASES
export const PURCHASES1                 = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/purchaseRequisitionHeaders"
export const PURCHREQNLINES             = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/purchaseRequisitionLines"
export const PLANNINGSPECIFICATIONS     = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/workPlanspecifications"
export const PURCHREQNAPPROVALREQUEST   = NAV_URL+"ODataV4/HRActions_SendPRApprovalRequest"
export const PURCHREQNCANCELAPPROVAL    = NAV_URL+"ODataV4/HRActions_CancelPRApprovalRequest"
export const REJECTPR                   = NAV_URL+"ODataV4/HRActions_RejectPRRequest"
export const APPROVEPR                  = NAV_URL+"ODataV4/HRActions_ApprovePRRequest"

// MUG PAYMENTS
export const PAYMENTS1                  = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/paymentRequisitions"
export const PMTREQNLINES               = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/paymentRequisitionLines"
export const VENDORLEDGERENTRIES        = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/vendorLedgerEntreis"
export const REQNTRANSACTIONTYPE        = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/transactionType"
export const SETAPPLIESTOID             = NAV_URL+"ODataV4/HRActions_ApplyEntries"    
export const UNAPPLYENTRIES             = NAV_URL+"ODataV4/HRActions_UnApplyEntries"         
export const PMTREQNAPPROVALREQUEST     = NAV_URL+"ODataV4/HRActions_sendPayApprovalRequest"
export const PMTREQNCANCELAPPROVAL      = NAV_URL+"ODataV4/HRActions_cancelPayApprovalRequest"
export const REJECTPMTREQN              = NAV_URL+"ODataV4/HRActions_rejectPaymentRequisition"
export const APPROVEPMTREQN             = NAV_URL+"ODataV4/HRActions_approvePaymentRequest"

//MUG TIMESHEETS
export const TIMESHEETS                 = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/timesheets"
export const PAYROLLEXPALLOCATIONS      = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/payRollExpallocation"
export const TIMESHEETSAPPROVALS        = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/timeSheetApprovalEntries"
export const PAYROLLSETUP               = NAV_URL+"api/hrpsolutions/mughrmis/v1.0/payRollSetup"
export const SENDTIMESHEETFORAPPROVAL   = NAV_URL+"ODataV4/HRActions_submitForApproval"
export const REJECTTIMESHEET            = NAV_URL+"ODataV4/HRActions_rejectTimesheet"
export const APPROVETIMESHEET           = NAV_URL+"ODataV4/HRActions_approveTimesheet"
export const REOPENTIMESHEET2           = NAV_URL+"ODataV4/HRActions_reopenstaffTimesheet"
export const REOPENTIMESHEET            = NAV_URL+"ODataV4/HRActions_reopensubmitedForApproval"









